import api from '../core/api';

export type PaymentBucket = 'cash' | 'wallet' | 'card';

export interface PaymentTransaction {
  _id: string;
  orderId: string;
  serviceKey: string;
  service: string;
  kind: string;
  reference: string;
  createdAt: string;
  customerName: string;
  customerContact: string;
  paymentMethod: string;
  paymentMethodLabel: string;
  paymentBucket: PaymentBucket;
  amount: number;
  discount: number;
  currency: string;
  promoCode?: string;
  orderStatus: string;
  orderStatusLabel: string;
  orderStatusGroup: 'completed' | 'active' | 'pending' | 'cancelled' | 'other';
  /** Raw payment status stored on the order. */
  paymentStatus: string;
  /** Payment outcome derived from payment status, order state and refunds. */
  paymentState: string;
  paymentStateLabel: string;
  paymentStateHint: string;
  transactionRef: string;
  transactionRefSource: string;
  gateway?: string;
  gatewayOrderId?: string;
  paidAt?: string;
  refundAmount: number;
  refundedAt?: string;
  refundRef?: string;
  refundDestination?: string;
  cancelledAt?: string;
  cancelReason?: string;
}

export type PaymentMethodSummary = Record<PaymentBucket | 'all', { count: number; amount: number }>;

export interface PaymentTransactionParams {
  method?: string;
  service?: string;
  orderStatus?: string;
  paymentState?: string;
  search?: string;
  from?: string;
  to?: string;
  timezone?: string;
  page?: number;
  limit?: number;
}

export async function getPaymentTransactions(params: PaymentTransactionParams) {
  const res = await api.get('/analytics/payment-transactions', { params });
  return res.data as {
    data: PaymentTransaction[];
    meta: { total: number; page: number; limit: number; summary?: PaymentMethodSummary };
  };
}
